import styled from "styled-components";

export const Title = styled.h1`
  text-align: center;
  color: #32a871;
  padding: 20px 0px 5px 0px;
`;
